import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { ErrorBoundary } from '../ui/ErrorBoundary';
import { ToastContainer } from '../ui/ToastContainer';
import { NetworkStatus } from '../ui/NetworkStatus';
import { PageSkeleton } from '../ui/Skeleton';
import { useAccountTheme } from '../../hooks/useTheme';

export function DashboardLayout() {
  // Initialize account theme — applies CSS custom properties on mount
  useAccountTheme();
  const location = useLocation();

  return (
    <div className="flex min-h-screen bg-bg">
      <NetworkStatus />
      <Sidebar />
      <main id="main-content" className="flex-1 min-w-0 p-4 sm:p-6 lg:p-10 pt-16 lg:pt-10" role="main">
        <ErrorBoundary>
          <Suspense fallback={<PageSkeleton />}>
            <AnimatePresence mode="wait">
              <div key={location.pathname}>
                <Outlet />
              </div>
            </AnimatePresence>
          </Suspense>
        </ErrorBoundary>
      </main>
      <ToastContainer />
    </div>
  );
}
